import Button from '@/components/elements/Button';
import { RxHamburgerMenu, RxCross1 } from 'react-icons/rx';
interface HamburgerToggleProps {
  onToggle: () => void;
  isOpen: boolean;
  className?: string;
}

export function HamburgerToggle({ onToggle, isOpen = false, className }: HamburgerToggleProps) {
  return (
    <Button
      variant='icon'
      onClick={onToggle}
      className={className}
      data-cy='hamburger-toggle'
      aria-controls='header-navigation'
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
    >
      <div
        className={`absolute transition[opacity,transform] duration-200 transform ${isOpen ? 'opacity-0 scale-0' : 'opacity-100 scale-100'}`}
      >
        <RxHamburgerMenu className='h-5 w-5' />
      </div>
      <div
        className={`absolute transition[opacity,transform] duration-200 transform ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}`}
      >
        <RxCross1 className='h-5 w-5' />
      </div>
    </Button>
  );
}
